module.exports = __webpack_public_path__ + "23c699bcb0bb4ace268d13c987a6c3ff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/styles/img/our_services/live@3x.jpg
// module id = 670
// module chunks = 0